import { createSelector } from 'reselect';
import { FILTERS, TIME_PERIOD_FILTERS } from '../constants/FiltersConstants';
import { List } from 'immutable';
import { DEAL_STAGE } from '../constants/DealGroupingType';
const getSimpleFilters = state => state.filters;
export const getFilters = createSelector([getSimpleFilters], filters => filters.set(FILTERS.TEAM, List()));
export const getIsSinglePipeline = createSelector([getSimpleFilters], simpleFilters => simpleFilters.get(FILTERS.PIPELINE).size === 1);
export const getIsMultipipeline = createSelector([getSimpleFilters], simpleFilters => simpleFilters.get(FILTERS.PIPELINE).size > 1);
export const getPipelineFilter = createSelector([getFilters], filters => filters.get(FILTERS.PIPELINE));
export const getTimePeriodFilter = createSelector([getFilters], filters => {
  var _filters$get;
  return (_filters$get = filters.get(FILTERS.TIME_PERIOD)) !== null && _filters$get !== void 0 ? _filters$get : TIME_PERIOD_FILTERS.THIS_MONTH;
});
export const getDealGroupingTypeFilter = createSelector([getFilters], filters => {
  var _filters$get2;
  return (_filters$get2 = filters.get(FILTERS.DEAL_GROUPING_TYPE)) !== null && _filters$get2 !== void 0 ? _filters$get2 : DEAL_STAGE;
});
export const getDealStageFilter = createSelector([getFilters], filters => filters.get(FILTERS.DEAL_STAGE_GROUPINGS));
export const getForecastCategoryFilter = createSelector([getFilters], filters => filters.get(FILTERS.FORECAST_CATEGORY_GROUPINGS));
export const getForecastTypeFilter = createSelector([getFilters], filters => filters.get(FILTERS.FORECAST_TYPE));